import React from "react";

const newsArticlesArray = [
    {
        type: "video",
        thumbUrl: "thumb-ted",
        blurb:
            "It's not happiness that makes you grateful. It's gratefulness that makes you happy",
        logoUrl: "logo-ted.svg",
        articleUrl:
            "https://www.ted.com/talks/david_steindl_rast_want_to_be_happy_be_grateful"
    },
    {
        type: "article",
        blurb:
            "Much of our time and energy is spent pursuing things we currently don't have. Gratitude reverses our priorities to help us appreciate the people",
        logoUrl: "logo-greater_good.png",
        classes: "news-article__footer-logo--greater-good",
        articleUrl:
            "https://greatergood.berkeley.edu/article/item/how_gratitude_changes_you_and_your_brain"
    },
    {
        type: "article",
        thumbUrl: "thumb-inc",
        blurb: "Gratitude creates happiness",
        logoUrl: "logo-inc.png",
        classes: "news-article__footer-logo--inc",
        articleUrl:
            "https://www.inc.com/jessica-stillman/you-can-supercharge-your-happiness-with-this-simple-gratitude-practice-science-s.html"
    }
];

const orientationClass = index => {
    if (index === 0) {
        return "tall";
    } else {
        return "aside";
    }
};

const NewsArticles = () => (
    <div className="news-articles">
        {newsArticlesArray.map((article, index) => {
            return (
                <div
                    key={`article-${index}`}
                    className={`news-article news-article--${orientationClass(
                        index
                    )}`}
                >
                    {article.thumbUrl && (
                        <img
                            className="news-article__thumb"
                            src={require(`../../imgs/articles/${
                                article.thumbUrl
                            }.png`)}
                            alt=""
                        />
                    )}
                    <div className="news-article__body">
                        <p className="news-article__blurb">
                            &quot;
                            {article.blurb}
                            &quot;
                        </p>
                        <div className="news-article__footer">
                            {article.logoUrl && (
                                <img
                                    className={`news-article__footer-logo ${
                                        article.classes
                                    }`}
                                    src={require(`../../imgs/articles/${
                                        article.logoUrl
                                    }`)}
                                    alt=""
                                />
                            )}
                            <a
                                href={article.articleUrl}
                                className="news-article__footer-link"
                            >
                                {article.type === "article"
                                    ? "read more..."
                                    : "watch now..."}
                            </a>
                        </div>
                    </div>
                </div>
            );
        })}
    </div>
);

export default NewsArticles;



// WEBPACK FOOTER //
// ./src/components/landingPage/NewsArticles.jsx